import axios from 'axios'
import store from '../../vuex/store'
import { getServerApi } from '../../config/deployment'
import { getCurrentUserToken, getAnyFirebaseToken } from '../../platform/auth/services/authService'
import { performRequest_PUT } from '@/platform/utils/http/httpService'

let envUri = getServerApi()
let listingsV2Uri = envUri + '/api/listings/v2'

export const cloneListing = ({ propertyId, accountId }) => {
  return new Promise((resolve, reject) => {
    getCurrentUserToken()
      .then(token => {
        return axios.post(listingsV2Uri + '/clone', null, { headers: { 'Authorization': token }, params: { token: token, propertyId: propertyId, accountId: accountId } })
      })
      .then(resp => {
        resolve(resp.data.body)
      })
      .catch(err => {
        reject()
      })
  })

}

export const getListingPublic = (maaklerID) => {
  return new Promise((resolve, reject) => {
    getAnyFirebaseToken()
      .then(token => {
        axios.get(listingsV2Uri + '/public', { params: { token: token, maaklerID: maaklerID } })
          .then(resp => {
            resolve(resp.data.body)
          })
          .catch(err => {
            reject()
          })
      })
  })
}

export const getListingPrivate = (maaklerID, accountId) => {
  return new Promise((resolve, reject) => {
    getCurrentUserToken()
      .then(token => {
        let accountId = store.getters.selectedAccount
        if(!accountId) throw "missing selectedAccount id"
        return axios.get(listingsV2Uri, { params: { token: token, maaklerID: maaklerID, accountId: accountId } })
      })
      .then(resp => {
        resolve(resp.data.body)
      })
      .catch(err => {
        reject(err)
      })
  })
}



export const upsertListingDetails = (listingId, detailsType, details) => {
  return new Promise((resolve, reject) => {
    getCurrentUserToken()
      .then(token => {
        var data = {
          listingId: listingId,
          token: token
        }
        data[detailsType] = details

        var uri = ""
        if (detailsType == "contractDet") uri = listingsV2Uri + "/details/contract"
        else if (detailsType == "availDet") uri = listingsV2Uri + "/details/availability"
        else if (detailsType == "documentDet") uri = listingsV2Uri + "/details/document"
        else reject("missing detailsType")
        return updateActual(uri, data)
      })
      .then(resp => {
        resolve(resp)
      })
      .catch(err => {
        reject()
      })
  })
}

export const updateListingFields = ({ id, updates }) => {
  return new Promise((resolve, reject) => {
    getCurrentUserToken()
      .then(token => {
        var headers = { "Authorization": token };
        return performRequest_PUT(listingsV2Uri + "/details/" + id, updates, headers)
      })
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else reject(resp.error)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function updateActual(uri, data) {
  return new Promise((resolve, reject) => {
    axios.post(uri, data)
      .then(resp => {
        resolve(resp.data.body)
      })
      .catch(err => {
        console.log(err)
        reject()
      })
  })
}

export const updateFees = async ({ propertyId, fees }) => {
    const token = await getCurrentUserToken();
    const response = await performRequest_PUT(`${listingsV2Uri}/${propertyId}/fees`, {
        bookingFeeValue: fees.bookingFeeValue,
        bookingFeePercentage: fees.bookingFeePercentage,
    }, { 'Authorization': token });

    const { success, response: { data: { body: { success: result } = {} } = {} } = {} } = response;
    if (!success) {
        return false;
    }

    return Boolean(result);
};

export const checkPropertyAddress = async ({ city, street, streetNumber = null, apartmentNumber = null }) => {
    const response = await axios.get(`${listingsV2Uri}/properties/check-address`, {
        params: {
            city,
            street,
            streetNumber,
            apartmentNumber,
        }
    });

    return Boolean(response.data.body.exists);
};


// WEBPACK FOOTER //
// ./src/listings/repository/listingRepository.js